import { Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';

const commonGaps = {
  outer: { xs: 8, lg: 9 },
  section: { xs: 5, lg: 6 },
  item: { xs: 3, lg: 4 },
};

const squareImage = (sizeXs: number, sizeLg: number) => ({
  width: { xs: sizeXs, lg: sizeLg },
  height: { xs: sizeXs, lg: sizeLg },
});

export const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: commonGaps.outer,
  },
  headContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: commonGaps.section,
  },
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    mx: { xs: 5 },
    gap: { xs: 5, lg: 8 },
    '& .MuiTypography-body2': { m: 0 },
  },
  avatarInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 3, lg: 0 },
  },
  avatar: { ...squareImage(90, 120), '& img': { objectPosition: 'top' } },

  teaserContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    mx: { xs: 5 },
    gap: { xs: 5, lg: 8 },
    mb: { xs: 0, sm: 4, lg: 5 },
    '& .MuiTypography-body2': { m: 0 },
  },
  teaser: {
    ...squareImage(90, 120),
    background: 'red',
  },
  teaserImageContainer: {
    objectFit: 'cover',
    width: { xs: 90, lg: 120 },
    height: { xs: 60, lg: 80 },
    flexShrink: 0,
  },
  teaserImage: {
    width: '100%',
    height: '100%',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: commonGaps.outer,
  },
  formColumnSection: { display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: { xs: 5, lg: 2 } },
  formSection: { display: 'flex', flexDirection: 'column', gap: commonGaps.section },
  footerContainer: { display: 'flex', flexDirection: 'column', mt: { xs: 5, lg: 6 }, gap: commonGaps.outer },

  sendContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: commonGaps.section,
  },
  infoContainer: { whiteSpace: 'normal' },
  link: { underline: 'none', color: theme.palette.primary.main },
  legaCheckBox: { '& .MuiFormControlLabel-root': { m: 0 }, '& label': { gap: commonGaps.item } },
  sendButton: {
    mx: { xs: 5, lg: 6 },
    my: { xs: 5, lg: 8 },
  },

  successInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mx: 6,
    my: commonGaps.outer,
    gap: 8,
  },
  successOuterContainer: {
    mb: { xs: 0, sm: 9, md: 10 },
  },
  successIcon: { ...squareImage(36, 48) },
  successInfo: {
    textAlign: 'center',
  },

  successContainer: {
    fontSize: '36px',
    lineHeight: '36px',
    mb: 6,
    textAlign: 'center',
  },
  messageTypography: { textAlign: 'center', px: 5 },
  dividerContainer: { py: 6 },
  financeCertificateDescriptionTypography: {
    pt: 6,
  },
  financeButtonLabelContainer: {
    py: 6,
  },
});
